import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav
      className="bg-black bg-opacity-80 shadow-md fixed top-4 left-4 right-4 z-50 rounded-lg lg:max-w-4xl xl:left-0  xl:right-0 xl:max-w-5xl mx-auto px-4 lg:px-8"

      //  className="bg-black bg-opacity-80 shadow-md fixed top-4 left-4 right-4 z-50 rounded-lg lg:top-4 lg:left-16 lg:right-16 xl:left-64 xl:right-64 "
    >
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo */}
        <Link to="/">
          <img
            src="/assests/images/LandingPage/PixellLogo.png"
            width={100}
            height={100}
            alt="Logo"
            className="h-8 sm:h-10 w-auto"
          />
        </Link>
        {/* Hamburger Menu Button for Mobile */}
        <button className="text-white lg:hidden block" onClick={toggleMenu}>
          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={
                isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
              }
            />
          </svg>
        </button>

        {/* Navigation Links */}
        <ul
          className={`lg:flex lg:items-center lg:space-x-6  ${
            isMenuOpen ? "block" : "hidden"
          } absolute bg-black lg:bg-transparent top-16 left-4 right-4 rounded-lg p-4 lg:p-0 lg:static`}
        >
          <li>
            <Link
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              to="/"
              className={`py-2 lg:py-0 cursor-pointer ${
                location.pathname === "/"
                  ? "text-blue-500 font-bold"
                  : "text-white hover:text-blue-500"
              }`}
            >
              Home
            </Link>
          </li>
          {/* <li>
            <Link
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              to="/brand"
              className={`py-2 lg:py-0 cursor-pointer ${
                location.pathname === "/brand"
                  ? "text-blue-500 font-bold"
                  : "text-white hover:text-blue-500"
              }`}
            >
              Brand
            </Link>
          </li> */}
          <li>
            <Link
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              to="/vendor"
              className={`py-2 lg:py-0 cursor-pointer ${
                location.pathname === "/vendor"
                  ? "text-blue-500 font-bold"
                  : "text-white hover:text-blue-500"
              }`}
            >
              Vendor Partners
            </Link>
          </li>
          <li>
            <Link
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              to="/ip"
              className={`py-2 lg:py-0 cursor-pointer ${
                location.pathname === "/ip"
                  ? "text-blue-500 font-bold"
                  : "text-white hover:text-blue-500"
              }`}
            >
              Installation Partners
            </Link>
          </li>
          {/* <li>
            <Link
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              to="/aboutus"
              className={`py-2 lg:py-0 cursor-pointer ${
                location.pathname === "/aboutus"
                  ? "text-blue-500 font-bold"
                  : "text-white hover:text-blue-500"
              }`}
            >
              About Us
            </Link>
          </li> */}
          <li>
            <Link
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              to="/ContactUs"
              className={`py-2 lg:py-0 cursor-pointer ${
                location.pathname === "/ContactUs"
                  ? "text-blue-500 font-bold"
                  : "text-white hover:text-blue-500"
              }`}
            >
              Contact Us
            </Link>
          </li>
          <li>
            <Link
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              to="/blogs"
              className={`py-2 lg:py-0 cursor-pointer ${
                location.pathname === "/blogs"
                  ? "text-blue-500 font-bold"
                  : "text-white hover:text-blue-500"
              }`}
            >
              Blogs
            </Link>
          </li>
        </ul>

        {/* Button */}
        <Link
          to="/ContactUs"
          className="bg-white text-black py-2 px-4 rounded-lg hover:bg-gray-700 hover:text-white hidden lg:block"
        >
          Book A Demo{" "}
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
